import Headroom from "headroom.js";

function headrommInit() {
  // select your header or whatever element you wish
  const header = document.querySelector(".main-header");
  const headerMainHeight = document.querySelector(".main-header").offsetHeight;
  if (!header) {
    return
  }
  let options = {

    // vertical offset in px before element is first unpinned
    offset: {
      up: 0,
      down: headerMainHeight
    }
  };

  const headroom = new Headroom(header, options);
  headroom.init();
}
const scrollDirection = () => {
  const header = document.querySelector(".main-header")
  const headerMainHeight = document.querySelector(".main-header").offsetHeight;

  window.addEventListener("scroll", function () {

    if (window.pageYOffset <= headerMainHeight * 2) {
      if (!header.classList.contains("--no-transition")) {
        header.classList.add("--no-transition")

      }
    } else {
      if (header.classList.contains("--no-transition")) {
        header.classList.remove("--no-transition")
      }
    }

  }, false);
}
const heightResize = () => {

  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
//Resize

window.addEventListener("resize", function () {
  heightResize();
  headrommInit();
  if (window.matchMedia("(min-width: 62em)").matches) {
    const navMain = document.querySelector(".main-header__main-nav");
    if (navMain.classList.contains("js-transition")) {
      navMain.classList.remove("js-transition")
      headerNavHide();
      headerMaskHide();
    }
    desktopSubmenuResizeFix()
  }

});


//Header nav

function headerNavButtonClick() {
  const navMain = document.querySelector(".main-header__main-nav");
  const headerNavButton = document.querySelector(".main-header__nav-button");

  headerNavButton.addEventListener("click", function () {
    if (!navMain.classList.contains("js-open")) {
      headerNavShow();
      headerMaskShow();

    } else {
      headerNavHide();
      headerMaskHide();
    }
    if (!navMain.classList.contains("js-transition")) {
      navMain.classList.add("js-transition");
    }
  });
}

function headerNavShow() {
  const navMain = document.querySelector(".main-header__main-nav");
  const headerNavButton = document.querySelector(".main-header__nav-button");
  const headerBrand = document.querySelector(".main-header__brand");
  const body = document.querySelector("body");
  const html = document.querySelector("html");

  navMain.classList.add("js-open");
  headerNavButton.classList.add("js-open");
  headerBrand.classList.add("js-open");
  body.classList.add("js-no-scroll");
  html.classList.add("js-no-scroll");
}

function headerNavHide() {
  const navMain = document.querySelector(".main-header__main-nav");
  const headerNavButton = document.querySelector(".main-header__nav-button");
  const headerBrand = document.querySelector(".main-header__brand");
  const body = document.querySelector("body");
  const html = document.querySelector("html");

  navMain.classList.remove("js-open");
  headerNavButton.classList.remove("js-open");
  headerBrand.classList.add("js-open");
  html.classList.remove("js-no-scroll");
  body.classList.remove("js-no-scroll");

  //Sub menu close
  const subMenuButtons = document.querySelectorAll(".sub-menu-button");
  if (subMenuButtons) {

    subMenuButtons.forEach(button => {
      if (button.classList.contains("js-open")) {
        button.classList.remove("js-open");
      }
      button.parentNode.classList.remove("js-open")
      if (button.parentNode.classList.contains("js-open")) {
        button.parentNode.querySelector(".sub-menu").classList.remove("js-open");
      }

    });
  }
  if (navMain.querySelector(".sub-menu")) {
    navMain.querySelector(".sub-menu").classList.remove("js-open");
  }
}

//Header Mask
function headerMaskClick() {
  const headerMask = document.querySelector(".header-mask");
  headerMask.addEventListener("click", function () {
    headerNavHide();
    headerMaskHide();
  });
}

function headerMaskShow() {
  const headerMask = document.querySelector(".header-mask");
  headerMask.classList.add("js-active");
}

function headerMaskHide() {
  const headerMask = document.querySelector(".header-mask");
  headerMask.classList.remove("js-active");
}


//Desktop submenu
function desktopSubmenu() {
  if (window.matchMedia("(min-width: 62em)").matches) {
    const subMenuItemHasChildren = document.querySelectorAll(".main-nav__list>.menu-item-has-children")

    for (let i = 0; i < subMenuItemHasChildren.length; i++) {
      subMenuItemHasChildren[i].addEventListener("mouseover", function () {
        let subMenu = subMenuItemHasChildren[i].querySelector(".sub-menu")
        let leftOffset = subMenu.getBoundingClientRect().left;
        let elWidht = subMenu.offsetWidth;

        if (window.innerWidth <= leftOffset + elWidht + 15) {
          subMenu.classList.add("js-sub-menu-left");
        }
      });
    }
  }
}

function desktopSubmenuResizeFix() {
  if (window.matchMedia("(min-width: 62em)").matches) {
    const subMenuItemHasChildren = document.querySelectorAll(".main-nav__list>.menu-item-has-children")

    for (let i = 0; i < subMenuItemHasChildren.length; i++) {
      let subMenu = subMenuItemHasChildren[i].querySelector(".sub-menu")
      let leftOffset = subMenu.getBoundingClientRect().left;
      let elWidht = subMenu.offsetWidth;

      if (subMenu.classList.contains("js-sub-menu-left")) {
        if (!window.innerWidth <= leftOffset + elWidht + 15) {

          subMenu.classList.remove("js-sub-menu-left");
        }
      }
    }
  }

}

//Mobile submenu init
function mobileSubmenuInit() {
  const menuItemHasChildren = document.querySelectorAll(".menu-item-has-children")

  menuItemHasChildren.forEach(item => {
    item.insertAdjacentHTML('beforeend', '<span class="sub-menu-button"></span>');
  });
}

//Mobile submenu
function mobileSubmenu() {
  const subMenuButtons = document.querySelectorAll(".sub-menu-button");
  subMenuButtons.forEach(button => {
    button.addEventListener("click", function () {
      let item = button
      if (!item.classList.contains("js-open")) {
        item.classList.add("js-open");
        item.parentNode.classList.add("js-open");
        item.parentNode.querySelector(".sub-menu").classList.add("js-open");

      } else {
        item.classList.remove("js-open");
        item.parentNode.classList.remove("js-open");
        item.parentNode.querySelector(".sub-menu").classList.remove("js-open");


        if (item.parentNode.querySelector(".sub-menu .sub-menu")) {
          item.parentNode.querySelector(".sub-menu .sub-menu").classList.remove("js-open");
        }
      }
    });
  });
}

heightResize();
headrommInit();
headerNavButtonClick();
headerMaskClick();
desktopSubmenu();
mobileSubmenuInit();
mobileSubmenu();
scrollDirection();
